// En: src/services/UploadService.ts

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api/v1';

export const uploadImage = async (file: File, context: 'projects' | 'articles' | 'team', id: number): Promise<{ url: string }> => {
    const formData = new FormData();
    formData.append('file', file);
    
    const response = await fetch(`${API_BASE_URL}/upload/image/${context}/${id}`, {
        method: 'POST',
        body: formData,
    });

    if (!response.ok) {
        const err = await response.json();
        throw new Error(err.message || 'Falló la subida del archivo.');
    }
    return response.json();
};

export const deleteImages = async (imageUrls: string[]): Promise<boolean> => {
    if (imageUrls.length === 0) return true;
    
    try {
        const paths = imageUrls.map(url => new URL(url).pathname.substring(1));
        const response = await fetch(`${API_BASE_URL}/upload/images`, {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ paths }),
        });
        return response.ok;
    } catch (error) {
        console.error("Error al procesar o eliminar las imágenes:", error);
        return false;
    }
};